import styled from '@emotion/styled'
import sanitizeHtml from 'sanitize-html'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import TemplateAccordions from './TemplateAccordions'
import { data } from './data/templateData'

const copy = {
  heading: `Sample code to get you started`,
  description: `Try out these pre-built Functions templates on <a href="https://segment.com/signup/">a free workspace</a> today!`,
}

const TemplatesToGetStarted = () => {
  return (
    <Wrapper>
      <SectionComponent variant="centered">
        <Section.Copy>
          <CopyTextBase centered={true}>
            <CopyText.Heading tag="h3">{copy.heading}</CopyText.Heading>
            <CopyText.Description
              tag="p"
              variant="pLarge"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(copy.description, { allowedTags: [`a`] }),
              }}
            />
          </CopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <TemplateAccordions data={data} />
        </Section.Contents>
      </SectionComponent>
    </Wrapper>
  )
}

const Wrapper = styled.div``

const SectionComponent = styled(SectionBase)`
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-top: 120px;
    }
    row-gap: 35px;
  }
`

export default TemplatesToGetStarted
